import React from 'react'
import * as PropTypes from 'prop-types'

import { FileImageOutlined } from '@ant-design/icons'

import { Upload, message } from 'antd'

import { withOrderFormContext } from '../../contexts'
import { uploadImages } from '../../services/api'

class Uploader extends React.Component {
  static propTypes = {
    addUploadedImage: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      isUploading: false,
      currentFileIndex: 0,
      allFiles: [],
      fileList: [],
    }

    this.onChange = this.onChange.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.beforeUpload = this.beforeUpload.bind(this)
  }

  beforeUpload(file, fileList) {
    this.setState({
      allFiles: fileList.map(f => {
        f.triedCount = 0
        return f
      })
    })

    const {
      getQuantitySetFromFrameSize,
      frameSize,
      selectedShape,
      images,
    } = this.props

    if (selectedShape !== 'COLLECTION') {
      return true
    }

    const limitQuantity = getQuantitySetFromFrameSize(frameSize)
    const isQuantityExceed = (images.length + fileList.length) > limitQuantity
    const isAllowed = !isQuantityExceed

    // PM-427: Do not allow customer upload more than collection's photo quantity
    // Credit: https://stackoverflow.com/questions/71870446/antd-file-upload-validation-in-reactjs
    if (isQuantityExceed) {
      message.error(`You could not upload more than ${limitQuantity} photos for this product`)
    }

    return isAllowed
  }

  onChange({ file, fileList }) {
    this.setState({ fileList })

    if (file.status === 'done' && file.response) {
      const { addUploadedImage } = this.props
      addUploadedImage(file.response)
    }

    if (file.status === 'done' || file.status === 'error') {
      setTimeout(() => {
        this.setState((prevState) => {
          return { fileList: prevState.fileList.filter(f => f.uid !== file.uid) }
        })
      }, 1500)
    }
  }

  incrementUpload(currentIndex, fileList) {
    // Increment and set isUploading to false
    this.setState({
      currentFileIndex: currentIndex + 1,
      isUploading: false,
      fileList: fileList,
    })
  }

  resetLists() {
    this.setState({
      allFiles: [],
      fileList: [],
      currentFileIndex: 0
    })
  }

  async handleUpload({ file, onSuccess, onProgress, onError }) {
    const uploadFilesCount = this.state.allFiles.length
    const currentIndex = this.state.currentFileIndex
    const currentFile = this.state.allFiles[currentIndex]

    if (currentIndex < uploadFilesCount && this.state.isUploading === false && currentFile.triedCount < 3) {
      this.setState({ isUploading: true })

      uploadImages(currentFile, {
        onUploadProgress: e => {
          onProgress({ percent: (e.loaded / e.total) * 100 })
        },
      }).then((image) => {
        // Add uploaded file to context
        this.props.addUploadedImage(image)

        // Remove uploaded file from list
        const fileList = this.state.fileList.filter(f => f.uid !== currentFile.uid)

        // Increment upload
        this.incrementUpload(currentIndex, fileList)

        // Reset lists when all files are uploaded
        if (currentIndex === this.state.allFiles.length - 1) {
          this.resetLists()
        }

        // Repeat uploading until all files are uploaded
        this.handleUpload({ file, onSuccess, onProgress, onError })
      }).catch((e) => {
        onError(e)

        // Mark as failed, need to retry uploading for a second time
        const allFiles = this.state.allFiles.map((f) => {
          if (f.uid === currentFile.uid) {
            f.triedCount = f.triedCount ? f.triedCount + 1 : 1
          }
          return f
        })

        this.setState({
          allFiles: allFiles,
          isUploading: false
        })
        // End Mark as failed

        // Increment upload after failed twice
        if (currentFile.triedCount === 2) {
          this.incrementUpload(currentIndex, this.state.fileList)
        }

        // Reset lists when all files are uploaded
        if (currentIndex === this.state.allFiles.length - 1) {
          this.resetLists()
        }

        // Continue uploading until all files are uploaded
        this.handleUpload({ file, onSuccess, onProgress, onError })
      })
    }
  }

  render() {
    return (
      <div>
        <Upload.Dragger
          disabled={this.props.maxQuantity !== null && this.props.images.length >= this.props.maxQuantity}
          multiple={this.props.maxQuantity !== 1}
          name="file"
          listType="image"
          fileList={this.state.fileList}
          onChange={this.onChange}
          customRequest={this.handleUpload}
          beforeUpload={this.beforeUpload}
          className={this.props.maxQuantity !== null && this.props.images.length >= this.props.maxQuantity ? 'opacity-50' : ''}
        >
          <p className="ant-upload-drag-icon">
            <FileImageOutlined />
          </p>
          {this.props.maxQuantity !== null && this.props.images.length >= this.props.maxQuantity
            ? <p className="ant-upload-text">Only {this.props.maxQuantity} photo{this.props.maxQuantity > 1 ? 's' : ''} can be uploaded for this product.</p>
            : <p className="ant-upload-text">Click or drag {this.props.maxQuantity === 1 ? 'file' : 'files'} to this area to upload</p>}
        </Upload.Dragger>
      </div>
    )
  }
}

Uploader.propTypes = {
  addUploadedImage: PropTypes.any,
  frameSize: PropTypes.any,
  getQuantitySetFromFrameSize: PropTypes.func,
  selectedShape: PropTypes.any,
  images: PropTypes.array,
  maxQuantity: PropTypes.number,
}

export default withOrderFormContext(context => ({
  addUploadedImage: context.addUploadedImage,
  frameSize: context.frameSize,
  getQuantitySetFromFrameSize: context.getQuantitySetFromFrameSize,
  selectedShape: context.selectedShape,
  images: context.images,
  maxQuantity: context.maxQuantity,
}))(Uploader)
